// src/core/config/env.ts

const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname.endsWith(".lvh.me");

export const ENV = isLocal
  ? {
    // ✅ URL de l'API Auth (pas le frontend)
    API_BASE_URL: "https://api.auth.lvh.me:2000/api",

    API_STATUS: "/status",

    API_LOGIN: "/auth/login",
    API_REGISTER: "/auth/register",
    API_REFRESH: "/auth/refresh",
    API_ME: "/auth/me",
    API_LOGOUT: "/auth/logout",

    API_FORGOT_PASSWORD: "/auth/forgot-password",
    API_VERIFY_RESET_CODE: "/auth/verify-reset-code",
    API_RESET_PASSWORD: "/auth/reset-password",

    MYACCOUNT_APP_URL: "https://myaccount.lvh.me:2005",
    MYPROFILE_APP_URL: "https://myprofile.lvh.me:2004",

    // ===============================
    // NOTIFY API
    // ===============================

    NOTIFY_API_BASE_URL: "https://api.notify.lvh.me:2008/api",

    // ===============================
    // VAPID (Web Push)
    // ===============================

    VAPID_PUBLIC_KEY: "BKCttjJi15e8NZQg1cUcaG-alNNqEYpkUUE3amrgCDmJFTEIE0_a-NkcRF3ZLdzmLVtIS9M6Q7DmC84ZuUOYQVo",




  }
  : {
    API_BASE_URL: "https://api.auth.hubvex.com/api",

    API_STATUS: "/status",


    API_LOGIN: "/auth/login",
    API_REGISTER: "/auth/register",
    API_REFRESH: "/auth/refresh",
    API_ME: "/auth/me",
    API_LOGOUT: "/auth/logout",

    API_FORGOT_PASSWORD: "/auth/forgot-password",
    API_VERIFY_RESET_CODE: "/auth/verify-reset-code",
    API_RESET_PASSWORD: "/auth/reset-password",

    MYACCOUNT_APP_URL: "https://myaccount.hubvex.com",
    MYPROFILE_APP_URL: "https://myprofile.hubvex.com",


    // ===============================
    // NOTIFY API (PRODUCTION)
    // ===============================

    NOTIFY_API_BASE_URL: "https://api.notify.hubvex.com/api",

    // ===============================
    // VAPID (Web Push) PRODUCTION
    // ===============================

    VAPID_PUBLIC_KEY: "BKCttjJi15e8NZQg1cUcaG-alNNqEYpkUUE3amrgCDmJFTEIE0_a-NkcRF3ZLdzmLVtIS9M6Q7DmC84ZuUOYQVo",


  };